const leadingZeroes = (params: { value: number; max: number }) => {
  return ("0" + params.value).slice(-params.max);
};
export default leadingZeroes;
